export default __webpack_public_path__ + "static/media/component-177-2@2x.521a27ce.png";